// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children, requireCustomer = false }) => {
  const { user, loading, hasCustomer } = useAuth();

  // Add logging for debugging
  console.log("[ProtectedRoute] State:", {
    user: user
      ? {
          id: user.id,
          customerId: user.customerId,
          isSuperAdmin: user.isSuperAdmin,
        }
      : null,
    loading,
    hasCustomer: hasCustomer(),
    requireCustomer,
  });

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireCustomer && !hasCustomer()) {
    console.log("[ProtectedRoute] Access denied - no customer assigned");
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            No Customer Assigned
          </h1>
          <p className="text-gray-600">
            Please contact your administrator to assign you to a customer.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
